import { useEffect, type ReactNode } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

interface AdminLayoutProps {
  children: ReactNode;
}

const NAV_ITEMS = [
  { icon: 'ri-dashboard-line', label: '總覽', path: '/admin/dashboard' },
  { icon: 'ri-pages-line', label: '頁面管理', path: '/admin/pages' },
  { icon: 'ri-price-tag-3-line', label: '維修報價管理', path: '/admin/pricing' },
  { icon: 'ri-newspaper-line', label: '最新消息管理', path: '/admin/news' },
];

export default function AdminLayout({ children }: AdminLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!sessionStorage.getItem('admin_auth')) navigate('/admin');
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem('admin_auth');
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Admin Navbar */}
      <header className="bg-gray-900 text-white px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img
            src="https://static.readdy.ai/image/15419bedb578ec59343dd2ae27ec91d5/bcd8c2dce83612dc3328f52b56b1caf2.png"
            alt="Logo"
            className="h-8 w-auto object-contain"
            style={{ filter: 'drop-shadow(0 0 6px rgba(255,255,255,0.2))' }}
          />
          <span className="text-gray-400 text-sm">後台管理</span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/" target="_blank" className="text-gray-400 hover:text-white text-sm cursor-pointer whitespace-nowrap">
            查看前台 →
          </Link>
          <button
            onClick={handleLogout}
            className="px-4 py-1.5 bg-gray-700 hover:bg-gray-600 text-white text-sm rounded-lg cursor-pointer whitespace-nowrap"
          >
            登出
          </button>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className="w-56 bg-white border-r border-gray-100 min-h-screen pt-6 flex-shrink-0">
          <nav className="px-4 space-y-1">
            {NAV_ITEMS.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors cursor-pointer ${
                    isActive ? 'bg-orange-50 text-orange-500' : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={item.icon} />
                  </div>
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-8 min-w-0">
          {children}
        </main>
      </div>
    </div>
  );
}
